module.exports = __webpack_public_path__ + "static/img/no_list_bg.8bd39804.png";